var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{staticClass:"donut-svg-background",attrs:{"cx":_vm.centerX,"cy":_vm.centerY,"r":_vm.radius,"stroke-width":_vm.strokeWidth}})}
var staticRenderFns = []

export { render, staticRenderFns }